import { render, staticRenderFns } from "./FCCApplicationDetails.vue?vue&type=template&id=3652bfb6"
import script from "./FCCApplicationDetails.vue?vue&type=script&lang=js"
export * from "./FCCApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./FCCApplicationDetails.vue?vue&type=style&index=0&id=3652bfb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports